"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncWithTarget = void 0;
const tslib_1 = require("tslib");
const debug_1 = tslib_1.__importDefault(require("debug"));
/**
 * Attempts to sync the current process with the target window.
 * @arg {Window} target the target window to synchronize with
 * @arg {Window} listener the source window that will receive the responses
 * @returns {Promise<void>} a promise that will either resolve if synchronization
 * succeeded or rejects if synchronization times out.
 * @notes
 * This method will send out a message payload of
 *     { type: 'sync-request', id: '<random string>' }
 * and will continue attempting to sync at 1 message at 30Hz for approximately 30 seconds.
 * The method will resolve when it receives a message payload on the listener window of
 *     { type: 'sync-response', id: '<id from sync-request>' }
 * The method will reject if all 1,000 attempts go by
 */
async function syncWithTarget(target, listener) {
    const id = btoa(`${Math.random()}`);
    const debug = (0, debug_1.default)(`ac:sync-target:${btoa(`${Math.ceil(Math.random() * 1000)}`)}`);
    debug('attempting to sync to target window with id', id, target);
    // maximum attempts is 30 times a second for 30 seconds.
    const interval = 1000 / 30;
    const maxAttempts = 30 * 30;
    let connected = false;
    let counter = 0;
    return new Promise((resolve, reject) => {
        function handler(event) {
            const { data } = event;
            if (typeof data !== 'object' || !data) {
                return;
            }
            if ('type' in data && data.type === 'sync-response') {
                if ('id' in data && data.id === id) {
                    debug('received correct sync response for id', id);
                    connected = true;
                    listener.removeEventListener('message', handler, { capture: true });
                    return resolve(event.origin);
                }
                debug('received sync response for another id', data.id);
            }
        }
        function ping() {
            if (counter < maxAttempts && !connected) {
                counter++;
                debug('sending sync pulse', counter);
                target.postMessage({ type: 'sync-request', id }, '*');
                setTimeout(ping, interval);
                return;
            }
            listener.removeEventListener('message', handler, { capture: true });
            if (!connected) {
                debug('sync signal failed after too many attempts');
                return reject(new Error('Unable to sync with target'));
            }
        }
        listener.addEventListener('message', handler, { capture: true });
        ping();
    });
}
exports.syncWithTarget = syncWithTarget;
//# sourceMappingURL=sync.js.map